import { Link } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { FadeUp, Overline } from "@/components/Reveal";
import { PRODUCTS } from "@/data/products";

export default function Products() {
  return (
    <div className="bg-white min-h-screen" data-testid="products-page">
      <Seo
        title="Products — Advanced Compute, Enterprise Hardware & Technology | Royal Deals FZ-LLC"
        description="Enterprise GPUs, servers, processors, memory, storage, networking, computer components and consumer technology — B2B technology supply from Royal Deals FZ-LLC, UAE."
      />
      <Nav />
      <main className="pt-44 pb-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <FadeUp>
            <Overline>Products</Overline>
            <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight text-midnight">
              Advanced compute first. Full-spectrum technology supply.
            </h1>
            <p className="text-midnight/55 text-lg mt-6 max-w-2xl leading-relaxed">
              Eight product families, one commercial standard: structured B2B procurement with international sourcing and professional execution.
            </p>
          </FadeUp>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
            {PRODUCTS.map((p, i) => (
              <FadeUp key={p.slug} delay={i * 0.05}>
                <Link
                  to={`/products/${p.slug}`}
                  data-testid={`product-card-${p.slug}`}
                  className="block bg-white hairline p-8 h-full group hover:border-gold/40 hover:shadow-medium transition-[border-color,box-shadow] duration-300"
                >
                  <p className="text-xs font-bold tracking-[0.2em] text-gold mb-4">{String(i + 1).padStart(2, "0")}</p>
                  <h2 className="font-heading text-xl font-medium text-midnight group-hover:text-gold transition-colors">{p.name}</h2>
                  <p className="text-sm text-midnight/55 mt-3 leading-relaxed">{p.intro.split("—")[0]}</p>
                </Link>
              </FadeUp>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
